export * from '@fhs/routing/src/routes/(tabs)/menu/(menu)/index';
export { default } from '@fhs/routing/src/routes/(tabs)/menu/(menu)/index';
